"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getIconUrl = function getIconUrl(icon) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'jpg';
  return require("@/assets/componentsLibraryIcons/".concat(icon, ".").concat(format));
};
var componentLibrary = [{
  title: '基础组件',
  components: [{
    title: '轮播图',
    key: 'carousel',
    formKey: 'carouselForm',
    showType: 1,
    bannerPadding: {
      pt: 10,
      pb: 10,
      pl: 15,
      pr: 15
    }
  }, {
    title: '导航组',
    key: 'navList',
    formKey: 'navListForm',
    showType: 2,
    navPadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }, {
    title: '搜索框',
    key: 'search',
    formKey: 'searchForm',
    showType: 3,
    searchPadding: {
      pt: 14,
      pb: 14,
      pl: 15,
      pr: 15
    }
  }, {
    title: '图片魔方',
    key: 'arrangeImages',
    formKey: 'arrangeImagesForm',
    showType: 4,
    activePadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }, {
    title: '商品列表',
    key: 'goods',
    formKey: 'goodsForm',
    showType: 6,
    goodsPadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }, {
    title: '图片热区',
    key: 'hotspot',
    formKey: 'hotspotForm',
    showType: 5,
    imgActPadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }, {
    title: '促销列表',
    key: 'marketgoods',
    formKey: 'marketgoodsForm',
    showType: 8,
    marketPadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }, {
    title: '拼团商品',
    key: 'pintuan',
    formKey: 'pintuanForm',
    showType: 7,
    pinPadding: {
      pt: 0,
      pb: 0,
      pl: 15,
      pr: 15
    }
  }]
}];
var _default = exports.default = componentLibrary;